import { render, staticRenderFns } from "./CropperUploader.vue?vue&type=template&id=37dc78dc&scoped=true&"
import script from "./CropperUploader.vue?vue&type=script&lang=js&"
export * from "./CropperUploader.vue?vue&type=script&lang=js&"
import style0 from "./CropperUploader.vue?vue&type=style&index=0&id=37dc78dc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37dc78dc",
  null
  
)

export default component.exports